"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// NOTE: the emailed code is 6 alphanumeric characters, one circle each
var OTP_LENGTH = 6;

var LoginOtpFormComponent = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(LoginOtpFormComponent, _Vue);

  var _super = _createSuper(LoginOtpFormComponent);

  function LoginOtpFormComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LoginOtpFormComponent);
    _this = _super.apply(this, arguments);
    _this.otpDigits = _this.getEmptyDigits();
    _this.focusedDigit = -1;
    return _this;
  }

  (0, _createClass2.default)(LoginOtpFormComponent, [{
    key: "digitIndexes",
    get: function get() {
      return Array.from({
        length: OTP_LENGTH
      }, function (_value, index) {
        return index;
      });
    }
  }, {
    key: "code",
    get: function get() {
      return this.otpDigits.join('');
    }
  }, {
    key: "isComplete",
    get: function get() {
      return this.code.length === OTP_LENGTH;
    }
  }, {
    key: "isResendDisabled",
    get: function get() {
      return this.isLoading || this.resendCountdown > 0;
    }
  }, {
    key: "resendLabel",
    get: function get() {
      return this.resendCountdown > 0 ? this.$t('login.otpResendIn', {
        seconds: this.resendCountdown
      }) : this.$t('login.otpResend');
    } // NOTE: the login page swaps this form in with a v-if, so a fresh mount is a fresh code

  }, {
    key: "mounted",
    value: function mounted() {
      this.focusDigit(0);
    }
  }, {
    key: "clearCode",
    value: function clearCode() {
      this.otpDigits = this.getEmptyDigits();
      this.writeDigits();
      this.focusDigit(0);
    }
  }, {
    key: "getEmptyDigits",
    value: function getEmptyDigits() {
      return new Array(OTP_LENGTH).fill('');
    } // NOTE: the emailed code is upper case, typing it in lower case still signs the user in

  }, {
    key: "sanitize",
    value: function sanitize(value) {
      return (value || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    }
  }, {
    key: "isDigitActive",
    value: function isDigitActive(index) {
      return this.focusedDigit === index || Boolean(this.otpDigits[index]);
    }
  }, {
    key: "getDigitInput",
    value: function getDigitInput(index) {
      var ref = this.$refs["digit".concat(index)];
      return Array.isArray(ref) ? ref[0] : ref;
    } // NOTE: a rejected character leaves the model untouched, so the circle it was typed in
    // keeps showing it until the value is written back by hand

  }, {
    key: "writeDigits",
    value: function writeDigits() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.digitIndexes.forEach(function (index) {
          var input = _this2.getDigitInput(index);

          if (input) {
            input.value = _this2.otpDigits[index] || '';
          }
        });
      });
    }
  }, {
    key: "focusDigit",
    value: function focusDigit(index) {
      var _this3 = this;

      this.$nextTick(function () {
        var input = _this3.getDigitInput(index);

        if (input) {
          input.focus();
          input.select();
        }
      });
    }
  }, {
    key: "setDigit",
    value: function setDigit(index, value) {
      var digits = (0, _toConsumableArray2.default)(this.otpDigits);
      digits[index] = value;
      this.otpDigits = digits;
      this.writeDigits();
    } // NOTE: one character per circle, a pasted or autofilled code spills into the ones after it

  }, {
    key: "fillFrom",
    value: function fillFrom(index, value) {
      var characters = this.sanitize(value).split('');

      if (!characters.length) {
        return;
      }

      var digits = (0, _toConsumableArray2.default)(this.otpDigits);
      var cursor = index;

      var _iterator = _createForOfIteratorHelper(characters),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var character = _step.value;

          if (cursor >= OTP_LENGTH) {
            break;
          }

          digits[cursor] = character;
          cursor++;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.otpDigits = digits;
      this.writeDigits();
      this.focusDigit(Math.min(cursor, OTP_LENGTH - 1));
    }
  }, {
    key: "onDigitInput",
    value: function onDigitInput(event, index) {
      var typed = this.sanitize(event.target.value);

      if (!typed) {
        this.setDigit(index, '');
        return;
      }

      this.fillFrom(index, typed);
    }
  }, {
    key: "onDigitKeyDown",
    value: function onDigitKeyDown(event, index) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.submit();
        return;
      }

      if (event.key === 'Backspace') {
        event.preventDefault(); // NOTE: an empty circle hands the backspace over to the one before it

        if (this.otpDigits[index]) {
          this.setDigit(index, '');
          return;
        }

        if (index > 0) {
          this.setDigit(index - 1, '');
          this.focusDigit(index - 1);
        }

        return;
      }

      if (event.key === 'ArrowLeft' && index > 0) {
        event.preventDefault();
        this.focusDigit(index - 1);
        return;
      }

      if (event.key === 'ArrowRight' && index < OTP_LENGTH - 1) {
        event.preventDefault();
        this.focusDigit(index + 1);
      }
    }
  }, {
    key: "onDigitPaste",
    value: function onDigitPaste(event, index) {
      event.preventDefault();
      this.fillFrom(index, event.clipboardData ? event.clipboardData.getData('text') : '');
    } // NOTE: selecting on focus lets the next key replace a circle that is already filled

  }, {
    key: "onDigitFocus",
    value: function onDigitFocus(event, index) {
      this.focusedDigit = index;
      event.target.select();
    }
  }, {
    key: "onDigitBlur",
    value: function onDigitBlur() {
      this.focusedDigit = -1;
    }
  }, {
    key: "submit",
    value: function submit() {
      if (!this.isComplete || this.isLoading) {
        return;
      }

      this.$emit('submit', this.code);
    }
  }, {
    key: "resend",
    value: function resend() {
      if (this.isResendDisabled) {
        return;
      }

      this.clearCode();
      this.$emit('resend');
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.$emit('cancel');
    }
  }]);
  return LoginOtpFormComponent;
}(_vuePropertyDecorator.Vue);

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], LoginOtpFormComponent.prototype, "isLoading", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: true
})], LoginOtpFormComponent.prototype, "isSent", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 0
})], LoginOtpFormComponent.prototype, "resendCountdown", void 0);
LoginOtpFormComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LoginOtpFormComponent',
  components: {
    'el-alert': _elementUi.Alert,
    'el-button': _elementUi.Button
  }
})], LoginOtpFormComponent);
var _default = LoginOtpFormComponent;
exports.default = _default;